// Aggregators from pivottable.js
// https://github.com/nicolaskruchten/pivottable/blob/master/src/pivot.coffee

class Aggregator {
  constructor () {
    this.value = 0
  }

  push () {
    throw new Error('You must implement .push()')
  }

  toString () {
    return '' + this.value
  }
}

class Count extends Aggregator {
  push () {
    this.value++
  }
}

class Sum extends Aggregator {
  push (data) {
    this.value += data
  }
}

export default {
  count: Count,
  sum: Sum
}
